import { render, staticRenderFns } from "./ProfileCards.vue?vue&type=template&id=0778b3b2&"
import script from "./ProfileCards.vue?vue&type=script&lang=js&"
export * from "./ProfileCards.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports